import { CustomTooltip } from '@/components/custom-tooltip';
import './room-type-rate-tooltip.scss';
import { usePropertyContext } from 'context/propertyContext';
import { formatDateWithGivenFormatter } from 'features/dates/date-helpers';
import { twoDecimalRateFormatter } from 'pages/MyView/tableCustomCellRender';

interface RoomTypeRateTooltipProps {
	roomType: string;
	rate: number;
	stayDate: string;
	lastUpdated: string;
	children: React.ReactElement<any, any> & React.ReactNode;
}

const format = (value: string) =>
	formatDateWithGivenFormatter(value, 'M/DD/YY');

export const RoomTypeRateTooltip = ({
	roomType,
	rate,
	stayDate,
	lastUpdated,
	children,
}: RoomTypeRateTooltipProps) => {
	const { currencySymbol } = usePropertyContext();

	return (
		<CustomTooltip
			placement='bottom'
			backgroundColor='tw-bg-white'
			arrowColor='tw-fill-primary'
			arrow
			borderColor='tw-border-primary'
			content={
				<div className='room-type-rate-tooltip'>
					<div className='row'>
						<span className='label'>Stay Date</span>
						<span>{format(stayDate)}</span>
					</div>
					<div className='row'>
						<span className='label'>Room Type</span>
						<span>{roomType}</span>
					</div>
					<div className='row'>
						<span className='label'>Rec Rate</span>
						<span>
							{currencySymbol}
							{twoDecimalRateFormatter(rate)}
						</span>
					</div>
					<div className='row'>
						<span className='label'>Last Updated</span>
						<span>{format(lastUpdated)}</span>
					</div>
				</div>
			}
		>
			{children}
		</CustomTooltip>
	);
};
